import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=b80b3b06&scoped=true&"
import script from "./signin.vue?vue&type=script&lang=js&"
export * from "./signin.vue?vue&type=script&lang=js&"
import style0 from "./signin.vue?vue&type=style&index=0&id=b80b3b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80b3b06",
  null
  
)

export default component.exports